<template>
  <el-dialog
    title="广告品费用明细"
    :visible.sync="dialogVisible"
    width="1000px"
    class="advertCostDialog"
    @close="dialogCloseHandle"
  >
    <div class="common_readonly_template">
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
          <div>
            <div class="label">单号</div>
            <div class="text">{{ formData.giftBillId }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
          <div>
            <div class="label">费用总计</div>
            <div class="text">{{ formData.totalMoney }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div>
            <div class="label">收货信息</div>
            <div class="text">{{ formData.receiveInfo }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <commonTable ref="advertCostDialogTable" />
  </el-dialog>
</template>

<script>
import commonTable from 'components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
export default {
  data () {
    return {
      dialogVisible: false,
      formData: {}
    };
  },
  props: {
    advertCostDialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object
    }
  },
  watch: {
    advertCostDialogVisible (val) {
      if (val) {
        this.loadTable(this.rowData.advertiseExpenseDetails);
      }
      this.dialogVisible = val;
    }
  },
  components: {
    commonTable
  },
  methods: {
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    loadTable (data) {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._width('200')
          ._title('广告品名称')
          ._data('giftName')
      );
      tableRow.push(
        new TableColumns()
          ._width('200')
          ._title('单价')
          ._data('price')
      );
      tableRow.push(
        new TableColumns()
          ._width('200')
          ._title('计划数量')
          ._data('amount')
      );
      tableRow.push(
        new TableColumns()
          ._width('200')
          ._title('计划小计')
          ._data('totalMoney')
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.advertCostDialogTable.setColumn(column, {
          page: false
        });
        this.$refs.advertCostDialogTable.loadStaticTable(data.advertiseOrderDetails);
      });
      this.formData = data;
      if (this.formData.receivingTime) {
        this.formData.receivingTime = new Date(this.formData.receivingTime.replace(/-/g, '/')).format('yyyy-MM-dd');
      }
      if (!data.countryType) {
        this.formData.receiveInfo = `${data.consigneeName} ${data.consigneeTel} ${data.province} ${data.city} ${data.area} ${data.street ? data.street + ' ' : ''}${data.detailedAddress}`;
      } else {
        this.formData.receiveInfo = `${data.consigneeName} ${data.consigneeTel} ${data.country} ${data.detailedAddress}`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.common_readonly_template{
  margin-bottom: 20px;
  .val>span{
    margin-left: 20px;
    color: #3384FE;
    cursor: pointer;
  }
}
</style>
